module.exports = "/_next/static/images/movie-d6aa1f20c09d186f42c3f2b3abada23e.svg";